<template>
	<div class="d-flex flex-column">
		<b-button
			id="ProspItem"
			variant="outline"
			@click="$emit('open', prosp, convo)"
			:class="{ 'd-none': !visible }"
			class="border rounded p-0 m-1 flex-fill text-left bg-white"
		>
			<div class="d-flex py-2">
				<div class="position-relative" style="width: 3em">
					<b-button v-if="convo" variant="outline" :disabled="convo.Unread > 0" class="center p-0" style="margin-top:-10px" @click.stop.prevent="markUnread" pill>
						<div :class="{ 'read': !convo.Unread }" class="rounded-circle blue" style="width: 1em; height:1em" />
					</b-button>
					<b-button v-if="convo && convo.ScheduledCount"  variant="outline"  class="alarm-btn">
						<v-icon  class="text-blue start-default" scale="2" name="clock" ></v-icon>
					</b-button>
					<!-- <b-button v-if="isOverDue" variant="outline" class="center p-0">
						<div class="rounded-circle red" style="width: 1em; height:1em" />
					</b-button> -->
				</div>
				<div class="flex-fill d-flex flex-column pr-2">
					<div class="d-flex">
						<h5 class="flex-fill before-icon d-flex-wrapper">{{alias}} 
							<span  
								v-if="isOverDue.val" 
								:class="getClassName"
								:id="prosp.id"
							>!</span>
							<b-popover
								:target="prosp.id"
								triggers="hover"
								placement="auto"
								container="my-container"
								ref="popover"
								>
								<!-- <template #title>Task List</template> -->
								<!-- <div> -->
									<b-table-simple v-if="prosp.Tasks" bordered striped responsive hover class="mx-auto text-left middle-grid-sc">
										<b-thead head-variant="light">
											<b-tr class="text-center">
												<b-th>Due Date</b-th>
												<b-th>Task</b-th>
											</b-tr>
										</b-thead>
										<b-tbody>
											<b-tr
												:key="task.CreatedOn"
												class="text-left position-relative"
												v-for="task of TaskList"
												:class="{'table-danger': task.Status == 'draft' && (task.DueOn <= Date.now())}"
											>
												<b-td>{{$parseDate(task.DueOn)}}</b-td>
												<b-td class="pr-5 position-relative">{{task.Description}}
													<b-button v-if="task.Status != 'compeleted'"
														style="right: 25px"
														variant="outline"
														class="center-vert"
														@click="compeleteTask(task)"
													>
														<v-icon class="text-blue" name="check" />
													</b-button>
													<b-button
														style="right: 0"
														variant="outline"
														class="center-vert"
														@click="removeTask(task)"
													>
														<v-icon class="text-blue" name="times" />
													</b-button>
												</b-td>
											</b-tr>
										</b-tbody>
									</b-table-simple>
								<!-- </div> -->
							</b-popover>

							<div v-if="!prosp.Starred" @click.stop.prevent="startMessage()" style="margin-left: 5px;">
								<v-icon :class="{ 'show_star': !prosp.Starred }" class="text-white" scale="1" name="star" ></v-icon>
							</div>
							<span @click.stop.prevent="unStartMessage()" style="margin-left: 5px;">
								<v-icon v-if="prosp.Starred" class="text-blue start-default" scale="1" name="star" ></v-icon>
							</span>
						</h5>
					</div>
					<span id="message" style="color: gray" v-if="selectedSort < 1000 && selectedSort !== 1000 && selectedSort !== 1001">Created : {{$parseDate(prosp.DateCreated)}}</span>
					<span id="message" style="color: gray" v-if="selectedSort == 1000">Interviewed : {{InterviewedDate(prosp.Interviewed)}}</span>
					<span id="message" style="color: gray" v-if="selectedSort == 1001">Interview : {{InterviewedDate(prosp.Interviewed)}}</span>
				</div>
				<div class="d-flex align-items-center">
					<!-- @click.stop="singleCheckClick()" -->
					<div class="form-group" @click.stop="singleCheckClick()">
						<!-- <input type="checkbox" id="c1" v-model="prosp.isSelectedCheck" >
						<label for="c1"></label> -->
						<b-form-checkbox class="custom-checkbox-fill"   v-model="prosp.isSelectedCheck" name="checkbox-1"></b-form-checkbox>
					</div>
					<b-dropdown variant="outline" no-caret class="pipelineStageDropdownUI">
						<template v-slot:button-content>
							<v-icon class="text-blue" scale="1.2" name="ellipsis-v"/>
						</template>
						<b-dropdown-header>
							Move to
						</b-dropdown-header>
						<b-dropdown-item-button
							:key="i"
							v-for="(stage, i) in stages"
							v-show="prosp.Status != stage"
							@click.stop.prevent="changeStatus(stage)"
						>
							{{stage}}
						</b-dropdown-item-button>
						<div class="ArchivedDelete" v-if="(prosp.Status == 'Archived')"><span @click.stop.prevent="ArchivedDeleteSingle(prosp.Status)">Delete</span></div>
						<b-dropdown-divider />
						<b-dropdown-item-button
							v-if="prosp.Status != 'Archived'"
							@click.stop.prevent="changeStatus('Archived')"
						>
							Archived
						</b-dropdown-item-button>
						<!-- <b-dropdown-item-button
							v-if="prosp.Status"
							@click.stop.prevent="changeStatus(null)"
						>
							Uncatagorized
						</b-dropdown-item-button> -->
					</b-dropdown>
				</div>
			</div>
		</b-button>
	</div>
</template>

<script>
	import { db } from 'src/db.js'
	import moment from 'moment';
	import axios from "axios";
	import { mapState } from 'vuex';

	export default {
		name: "ProspectItem",
		props: {
			filter: Number,
			selectedSort:Number,
			prosp: {
				DateCreated: Number,
				Status: String,
				Number: String,
				First: String,
				Last: String,
				Tags: Array,
				Notes: Map,
				isSelectedCheck: Boolean
			},
		},
		computed: {
			alias() {
				let alias = this.$parseAlias(this.prosp);
				if (alias.length > 15) {
					return alias.slice(0, 15) + "...";
				}
				return alias;
			},
			stages() {
				return this.$store.state.firebase.user.Stages;
			},
			convo() {
				return this.$store.state.firebase.convos.find(convo => convo.ClientNumber == this.prosp.Number);
			},
			visible() {
				let val = true;
				// if (typeof this.selectedSort == 'string') {
				// 	this.selectedSort = parseInt(this.selectedSort);
				// }
				if (this.selectedSort) {
					if (this.selectedSort == 2) {
						val = (this.convo && this.convo.Unread);
					}
					if (this.selectedSort == 5) {
						val = (this.convo && this.convo.hasOwnProperty('ScheduledCount') && this.convo.ScheduledCount)
					}
					if (this.filter == 2) {
						val = (this.convo && this.convo.Unread);
					}
					if (this.filter == 5) {
						val = (this.convo && this.convo.hasOwnProperty('ScheduledCount') && this.convo.ScheduledCount)
					}
				}else {
					if (this.filter == 2) {
						val = (this.convo && this.convo.Unread);
					}
					if (this.filter == 5) {
						val = (this.convo && this.convo.hasOwnProperty('ScheduledCount') && this.convo.ScheduledCount)
					}
				}
				return val;
			},
			// isOverDue() {
			// 	let val = false
			// 	if(this.prosp && this.prosp.Tasks) {
			// 		for (let task of this.prosp.Tasks) {
			// 			if (task.DueOn && task.Status == 'draft' && (task.DueOn <= Date.now() || this.isToday(new Date(task.DueOn)))) {
			// 				val = true;
			// 				break	
			// 			}
			// 		}
					
			// 	}
			// 	return val
			// },
			isOverDue() {
				let val = false;
				let taskType = '';
				let tmpTask = [];
				if(this.prosp && this.prosp.Tasks) {
					for (let task of this.prosp.Tasks) {
						var date_3_day = new Date();
						date_3_day.setDate(date_3_day.getDate() + 3);
						// var date_1_day = new Date();
						// date_1_day.setDate(date_1_day.getDate() + 1);
						var end = new Date();
						end.setHours(23,59,59,999);
						taskType = 'gray';
						if (task.DueOn && task.Status == 'draft' && (this.isToday(new Date(task.DueOn)))) {
							taskType = 'red'
							val = true;
						}else if (task.DueOn && task.Status == 'draft' && (task.DueOn <= Date.now())) {
							taskType = 'red'
							val = true;
						}else if (task.DueOn && task.Status == 'draft' && (task.DueOn < (date_3_day.getTime()) && task.DueOn > (end.getTime()))) {
							val = true;
							taskType = 'yellow';
						}else if (task.DueOn && task.Status == 'compeleted') {
							val = false;
							taskType = '';
						}else{
							val = true;
							taskType = 'gray';
						}
						// tmpTask[tmpTask.length] = taskType;
						tmpTask.push({ val: val, taskType });
					}
				}
				const containsRed = tmpTask.some(task => task.taskType === 'red');
				const containsYellow = tmpTask.some(task => task.taskType === 'yellow');
				const containsGray = tmpTask.some(task => task.taskType === 'gray');
				if (containsRed) {
					return { val: true, taskType: 'red' };
				} else if (containsYellow) {
					return { val: true, taskType: 'yellow' };
				} else if (containsGray) {
					return { val: true, taskType: 'gray' };
				} else {
					return { val: false, taskType: '' };
				}
			},
			isOverDueOldCode() {
				let val = false;
				let taskType = '';
				let tmpTask = [];
				if(this.prospect && this.prospect.Tasks) {
					for (let task of this.prospect.Tasks) {
						var date_3_day = new Date();
						date_3_day.setDate(date_3_day.getDate() + 3);
						// var date_1_day = new Date();
						// date_1_day.setDate(date_1_day.getDate() + 1);
						var end = new Date();
						end.setHours(23,59,59,999);
						taskType = 'gray';
						if (task.DueOn && task.Status == 'draft' && (this.isToday(new Date(task.DueOn)))) {
							taskType = 'red'
							val = true;
						}else if (task.DueOn && task.Status == 'draft' && (task.DueOn <= Date.now())) {
							taskType = 'red'
							val = true;
						}else if (task.DueOn && task.Status == 'draft' && (task.DueOn < (date_3_day.getTime()) && task.DueOn > (end.getTime()))) {
							val = true;
							taskType = 'yellow';
						}else if (task.DueOn && task.Status == 'compeleted') {
							val = false;
							taskType = '';
						}else{
							val = true;
							taskType = 'gray';
						}
						tmpTask[tmpTask.length] = taskType;
					}
				}
				if(tmpTask.includes('red')) {
					return {val,taskType:"red"}		
				}else if(tmpTask.includes('yellow')) {
					return {val,taskType:"yellow"}
				}else{
					return {val,taskType}
				}
			},
			isOverDueOldLogic() {
				let val = false;
				let taskType = '';
				if(this.prosp && this.prosp.Tasks) {
					for (let task of this.prosp.Tasks) {
						var date_3_day = new Date();
						date_3_day.setDate(date_3_day.getDate() + 3);
						// var date_1_day = new Date();
						// date_1_day.setDate(date_1_day.getDate() + 1);
						var end = new Date();
						end.setHours(23,59,59,999);
						if (task.DueOn && task.Status == 'draft' && (this.isToday(new Date(task.DueOn)))) {
							taskType = 'red'
							val = true;
							break;
						}else if (task.DueOn && task.Status == 'draft' && (task.DueOn <= Date.now())) {
							taskType = 'red'
							val = true;
						}else if (task.DueOn && task.Status == 'draft' && (task.DueOn < (date_3_day.getTime()) && task.DueOn > (end.getTime()))) {
							val = true;
							taskType = 'yellow';
						}
						else if (task.DueOn && task.Status == 'draft') {
							val = true;
							taskType = 'gray';
						}
					}
					
				}
				return {val,taskType}
			},
			TaskList() {
				let unCompeletedTaskList = [];
				for (let task of this.prosp.Tasks) {
					var someDate = new Date();
					someDate.setDate(someDate.getDate() + 3);
					// if (task.DueOn && task.Status == 'draft' && ((task.DueOn <= (someDate.getTime()) && task.DueOn >=  Date.now() || task.DueOn <= Date.now()))) {
					// 	unCompeletedTaskList.push(task)
					// }
					// unCompeletedTaskList.push(task)
					if (task.DueOn && task.Status == 'draft') {
						unCompeletedTaskList.push(task)
					}
				}
				return unCompeletedTaskList;
			},
			getClassName() {
				let cname = '';
				if (this.isOverDue.taskType == 'yellow') {
					cname = 'yellow'
				}else if(this.isOverDue.taskType == 'gray') {
					cname = 'gray'
				}else if (this.isOverDue.taskType == 'red') {
					cname = 'red'
				}
				return cname;
			},
			...mapState('globals', ['startCount','unreadCountTotal','dueTaskCountTotal']),
		},
		methods: {
			ArchivedDeleteSingle(name) {
				if(name == 'Archived' && this.prosp) {
					if (confirm("Are you sure that you want to permanently delete all data associated with the prospects that have been selected?")) {
						let convoData = this.$store.state.firebase.convos;
						let userData = this.$store.state.firebase.user;
						let getConvoData = convoData.find(convo => convo.ClientNumber == this.prosp.Number);
						if(getConvoData) {
							db.doc(`Conversations/${getConvoData.id}`).delete();
						}
						db.doc(`Users/${userData.id}/Prospects/${this.prosp.id}`).delete();
					}
				} else {
					alert('Please select at leaset one prospect!');
				}
			},
			InterviewedDate(Interviewed) {
				return moment(Interviewed).format('M/DD/YYYY');
			},
			singleCheckClick() {
				// this.prosp.isSelectedCheck = true;
				//eslint-disable-next-line
				console.log(this.prosp);
			},
			async changeStatus(status) {
				var StatusArray1 = [];
				if(this.prosp.Stages != null || this.prosp.Stages != undefined) {
					StatusArray1 = this.prosp.Stages;
				}

				let StatusArray2 = [{Date:new Date().valueOf(), Stage:status}];
				let StatusArrayFinalOutput = [...StatusArray1, ...StatusArray2];
				let updatedQuery = {
					Status:status,
					Stages:StatusArrayFinalOutput
				}
				let user = this.$store.state.firebase.user;
				db.doc(`Users/${user.id}/Prospects/${this.prosp.id}`).update(updatedQuery);
				
				if(user.hasOwnProperty('stageSettings')) {
					let  getLateststageSettingsArray = [];
					getLateststageSettingsArray = user.stageSettings.filter(rp => rp.name == status);
					for(var k=0; k < getLateststageSettingsArray.length;) {
						await this.insertTheNewTask(getLateststageSettingsArray, k, user);
						k++;
					}
				}
			},
			async insertTheNewTask(getLateststageSettingsArray, k, user) {
				let nowUTC = new Date().valueOf(); // CURRENT DATE/TIME
				let nowUTCAdded = nowUTC + (getLateststageSettingsArray[k]['due'] * (24 * 60 * 60 * 1000))
				const taskData = {
					pid : user.id,
					cid : this.prosp.id,
					taskName : getLateststageSettingsArray[k]['desc'],
					dueDate : nowUTCAdded,
				};
				//eslint-disable-next-line
				// console.log("taskData", taskData);
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/createTask", taskData)
				.then(response => {
					//eslint-disable-next-line
					console.log("New Task Added Successfully", response);
				});
			},
			markUnread() {
				db.doc(`Conversations/${this.convo.id}`).update({Unread: 1});
				this.$store.commit('globals/SET', { var: 'unreadCountTotal', val: this.unreadCountTotal-1 });
				this.$store.dispatch('firebase/rebindConvosUnreadCount', {
					uid: this.user.Uid,
					id: this.user.id,
				})
			},
			isToday(date) {
				const today = new Date()
				return date.getDate() === today.getDate() &&
					date.getMonth() === today.getMonth() &&
					date.getFullYear() === today.getFullYear();
			},
			commonCreateNotes(notesAdd, user) {
				var notesArray1 = [];
				var nt = [];
                Object.assign(nt,this.prosp.Notes) ;
				if(this.prosp.hasOwnProperty('Notes') && nt != null || nt != undefined) {
					notesArray1 = nt;
				}
				let notesArray2 = [{
					'date': Date.now(),
					'description': notesAdd,
					'mediaURL': ''
				}];
				let notesFinalArray = [...notesArray1, ...notesArray2];
				db.doc(`Users/${user.id}/Prospects/${this.prosp.id}`).update({ Notes: notesFinalArray })
				.catch(err => {
					this.$emit('error', err);
				});
			},
			compeleteTask(key) {
				if (confirm("Are you sure you want to mark this task as completed?")) {
					let user = this.$store.state.firebase.user;
					// let i=0;
					let taskDesc = '';
					for (let t of this.prosp.Tasks) {
						if (key.CreatedOn == t.CreatedOn) {
							// this.prosp.Tasks.splice(i,1)
							t.Status = 'compeleted';
							t.CompletedOn = Date.now();
							// this.prosp.Tasks.splice(i,1)
							taskDesc = t.Description;
						}
						// i++;
					}
					db.doc(`Users/${user.id}/Prospects/${this.prosp.id}`).update({Tasks:this.prosp.Tasks});
					let noteMsg = "Task "+ taskDesc + " was completed";
					this.commonCreateNotes(noteMsg, user);
					const overdueProspects = this.prospects.filter(prospect => this.isOverDue(prospect));
					this.$store.commit('globals/SET', { var: 'dueTaskCountTotal', val: overdueProspects.length });
					/*
					let noteList = this.prosp.Notes;
					let firstNote = {};
					if (!noteList) {
						firstNote[Date.now()] = noteMsg;
					} else if (Object.keys(noteList).length > 0) {
						noteList[Date.now()] = noteMsg;
						firstNote = noteList;
					} else {
						firstNote[Date.now()] = noteMsg;
					}
					db.doc(`Users/${user.id}/Prospects/${this.prosp.id}`).update({Notes:firstNote});
					*/
				}
			},
			removeTask(key) {
				if (confirm("Are you sure you want to delete this task?")) {
					let user = this.$store.state.firebase.user;
					let i=0;
					for (let t of this.prosp.Tasks) {
						if (key.CreatedOn == t.CreatedOn) {
							this.prosp.Tasks.splice(i,1)
						}
						i++;
					}
					db.doc(`Users/${user.id}/Prospects/${this.prosp.id}`).update({Tasks:this.prosp.Tasks});
					const overdueProspects = this.prospects.filter(prospect => this.isOverDue(prospect));
					this.$store.commit('globals/SET', { var: 'dueTaskCountTotal', val: overdueProspects.length });
				}
			},
			startMessage() {
				let user = this.$store.state.firebase.user;
				db.doc(`Users/${user.id}/Prospects/${this.prosp.id}`).update({Starred:true});
				this.$store.dispatch('firebase/rebindConvosStarredCount', {
					uid: this.user.Uid,
					id: this.user.id,
				})
			},
			unStartMessage() {
				let user = this.$store.state.firebase.user;
				// let starred = true;
				// if (this.prospect.hasOwnProperty('Starred') && this.prospect.Starred) {
				// 	starred = false
				// }
				db.doc(`Users/${user.id}/Prospects/${this.prosp.id}`).update({Starred:false});
				this.$store.dispatch('firebase/rebindConvosStarredCount', {
					uid: this.user.Uid,
					id: this.user.id,
				})
			}
		}
	}
</script>

<style scoped>
	#message {
		font-size: 12px;
	}
	.read {
		background-color: transparent;
	}
	.read:hover {
		background-color: rgba(4,43,121,.3);
	}
	.red {
		background-color: transparent;
	}
	.before-icon .red {
		font-size: 18px;color: red;font-weight: 800;object-fit: contain;object-position: center;
		margin-right: 3px;
	}
	.before-icon .yellow {
		font-size: 18px; color:#ffc107; font-weight: 800; object-fit: contain; object-position: center;
	}
	.before-icon .gray  {
		font-size: 18px;
		color:gray;
		font-weight: 800;
		object-fit: contain;
		object-position: center;
	}
	h5.flex-fill.before-icon {
    font-size: 14px;
	display: flex;	
	}
	.show_star {
		background-color: white;
		width: 12px;
		height: 12px;
		margin-right: 3px;
	}
	.start-default {
		width: 12px !important;
		height: 12px!important;
		display: inline-block;
	}
	.show_star:hover {
		background-color: transparent;
		fill: rgba(4,43,121,.3);
	}
	.alarm-btn{
		padding: 0;
		height: 100%;
		display: flex;
		align-items: flex-end;
		justify-content: center;
		margin: auto;
		padding-bottom: 4px;
	}
	.form-group {
  display: block;
  margin-bottom: 0px;
}

.form-group input {
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer;

}

.form-group label {
  position: relative;
  cursor: pointer;
  margin: 0px !important;
}

.form-group label:before {
  content:'';
  -webkit-appearance: none;
  background-color: transparent;
  border: 2px solid #042b79;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
  padding: 8px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 0px;
}
.form-group input:checked + label:before{
	background-color: #042b79;
}

/* .form-group:hover{
	background-color:#ced3de;
} */
.form-group input:checked + label:after {
  content: '';
  display: block;
  position: absolute;
  top: 6px;
  left: 7px;
  width: 6px;
  height: 11px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}



</style>